import React from 'react'
import Nav from '../components/Nav'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../utils/globalstyle.js'
import 'prismjs/themes/prism-tomorrow.css'

class Template extends React.Component {
  render() {
    const { children } = this.props
    return (
      <div>
        <Nav />
          {children()}
      </div>
    )
  }
}

Template.propTypes = {
  children: React.PropTypes.func,
  location: React.PropTypes.object,
  route: React.PropTypes.object,
};

export default Template;


// WEBPACK FOOTER //
// ./src/layouts/index.js